import React, { useState, useEffect } from "react";
import { Container, Row, Col, Table } from "react-bootstrap";
import { useParams } from "react-router-dom";
import Logo from "../assets/logo.png";
import { baseURL } from "../store/api/axios";
import { encryptdata } from "../utils/encryptDecrypt";

const SubscriptionBill = () => {
  const [invoiceData, setInvoiceData] = useState(null);
  const { id } = useParams(); // Extract the ID from the URL

  const country = localStorage.getItem('country') || ''; 

  const getSymbol = (country) => {
    if (country === "United Kingdom") return '£';
    if (country === "India") return '₹';
    if (country === "Canada") return 'CA$';
    return ''; 
  };

  

  // Fetch Invoice Details from API
  const fetchSubscriptionInvoice = async () => {
    try {
      const encrypt = encryptdata({id})
      const response = await fetch(
        `${baseURL}masters/usersubscription/invoiceview/${id}`
      );
      if (!response.ok) {
        throw new Error("Failed to fetch invoice details");
      }
      const data = await response.json();
      setInvoiceData(data.data?.invoicedetails[0]); // Extract the first object in the array
    } catch (error) {
      console.error("Error fetching invoice data:", error);
    }
  };

  useEffect(() => {
    fetchSubscriptionInvoice();
    setTimeout(()=>{
      window.print();
  },3000)
  }, []);

  if (!invoiceData) {
    return (
      <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <div className="loaderMain"></div>
      </div>
    );
  }

  const {
    user,
    transactionId,
    title,
    invoiceNumber,
    plantype,
    amount,
    status,
    taxAmount,
    creditpoints,
    currency,
    createdAt,
    categoryName,
  } = invoiceData;

  // Formatting date
  const formatDate = (dateString) =>
    new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

 // Default tax
  const total = (amount || 0) + taxAmount; // Sum of amount and tax

  function capitalize(str) {
    if (!str) return 'N/A';  // Handle empty or falsy values
    return str
      .split(' ')  // Split the string into an array of words
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(' ');  // Join words back into a string
  }

  return (
    <div className="printable-content">
      <Container className="invoice-container p-4">
        {/* Header */}
        <Row className="mb-4">
          <Col md={6}>
            <img style={{ width: "25%" }} src={Logo} alt="logo" />
          </Col>
          <Col md={6} className="text-end">
            <h1 className="invoice-title">INVOICE</h1>
          </Col>
        </Row>

        {/* Invoice Details */}
        <Row className="mb-4">
          <Col md={6}>
            <h5 className="mb-0">INVOICE TO</h5>
            <h3>{user?.name || "N/A"}</h3>
            <p>{user?.companyName || "N/A"} Company</p>
            <p>
              Phone: {user?.mobileNo || "N/A"} <br />
              Email: {user?.email || "N/A"}
            </p>
          </Col>
          <Col md={6} className="text-end">
            <p className="mb-0">Invoice No: {invoiceNumber || "N/A"}</p>
            <p>Invoice Date: {formatDate(createdAt)}</p>
            <p style={{ fontWeight: "700" }}>
              Payment details <br />
              Transaction Id: {transactionId || "N/A"} <br />
              Payment Method: NET BANKING
            </p>
          </Col>
        </Row>

        {/* Table */}
        <Table className="invoice-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Plan Type</th>
              <th>Credit</th>
              <th>Pay type</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>01</td>
              <td>{title || "N/A"}</td>
              <td>{creditpoints || 'N/A'}</td>
              <td>{capitalize(categoryName || '')}</td>
              <td>{getSymbol(country)} {amount?.toFixed(2) || "N/A"}</td>
            </tr>
          </tbody>
        </Table>

        {/* Totals */}
        <Row className="mb-4">
          <Col md={8}>
            <p>
              <strong>Paid amount: </strong>{" "}
              <span className="total-due">{getSymbol(country)} {total.toFixed(2)} INR</span>
            </p>
            <p>No dues payment completed</p>
          </Col>
          <Col md={4}>
            <p className="text-end">Sub Total: {getSymbol(country)} {amount?.toFixed(2) || "N/A"}</p>
            <p className="text-end">Tax: {getSymbol(country)} {taxAmount?.toFixed(2)}</p>
            <h4 className="text-end total-amount">
              TOTAL: {getSymbol(country)} {total.toFixed(2)}
            </h4>
          </Col>
        </Row>
        <hr />

        {/* Terms */}
        {/* <Row>
          <Col md={6}>
            <h5>Terms & Conditions</h5>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
              eiusmod tempor incididunt ut labore et dolore magna aliqua.
            </p>
          </Col>
          <Col md={6}>
            <div className="text-end">
              <img
                style={{ width: "50%" }}
                src="https://www.signwell.com/assets/vip-signatures/bruce-lee-signature-40abf707b68d9bff51d53cfe915a429115247816f034e172a752b8f4ebc65b9f.svg"
                alt="signature"
              />
              <h6>Peter Christopher</h6>
              <span>Associate director</span>
            </div>
          </Col>
        </Row> */}
      </Container>
    </div>
  );
};

export default SubscriptionBill;




// import React, { useState,useEffect } from 'react';
// import { Container, Row, Col, Table } from 'react-bootstrap';
// import Logo from '../assets/logo.png';

// const SubscriptionBill = () => {

//   const [invoiceData, setInvoiceData] = useState(null)

//   const fetchSubscriptioninvoice = async () => {
//     try {
const encrypt = encryptdata('67927e299606aca0adae342c')
//       const response = await fetch(`${baseURL}masters/usersubscription/invoiceview/${encrypt}`)
//       const data = await response.json()
//       setInvoiceData(data.invoicedetails)
//     } catch (error) {
//       console.log(error);
//     }
//   }

//     useEffect(() => {
//       fetchSubscriptioninvoice()
//   }, []);



//       // setTimeout(()=>{
//     //     window.print();
//     // },3000)
//   return (
//     <div className="printable-content">
//       <Container className="invoice-container p-4">
//         {/* Header */}
//         <Row className="mb-4">
//           <Col md={6}>
//             {/* <h2 className="company-name">Blaccdot Corporate</h2>
//             <p>Your solution, your problems</p> */}
//             <img style={{width:'25%'}} src={Logo} alt='logo' />
//           </Col>
//           <Col md={6} className="text-end">
//             <h1 className="invoice-title">INVOICE</h1>
//           </Col>
//         </Row>

//         {/* Invoice Details */}
//         <Row className="mb-4">
//           <Col md={6}>
//             <h5 className="mb-0">INVOICE TO</h5>
//             <h3>Megumin Ryu</h3>
//             <p>Supervisor, Eucto Verse Company</p>
//             <p>
//               Phone: (+62) 898 1234 5678 <br />
//               Email: megumin_ryu@mail.com
//             </p>
//           </Col>
//           <Col md={6} className="text-end">
//             <p className='mb-0'>Invoice No: TA882838</p>
//             <p>Invoice Date: December 26th, 2026</p>
//             <p style={{fontWeight: '700'}}>
//           Payment <br />
//           Transaction Id: TTCNI022000800594 <br />
//           Payment Method: NET BANKING
//         </p>
//           </Col>
//         </Row>

//         {/* Table */}
//         <Table className="invoice-table">
//           <thead>
//             <tr>
//               <th>#</th>
//               <th>Plan Type</th>
//               <th>Duration</th>
//               <th>Pay type</th>
//               <th>Amount</th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>01</td>
//               <td>Premium</td>
//               <td>Monthly</td>
//               <td>Auto debit</td>
//               <td>7,999</td>
//             </tr>
//           </tbody>
//         </Table>

//         {/* Totals */}
//         <Row className="mb-4">
//           <Col md={8}>
//           <p>
//               <strong>Paid amount: </strong> <span className="total-due">₹8,149 INR</span>
//             </p>
//             <p>No dues payment completed</p>
//           </Col>
//           <Col md={4}>
//             <p className="text-end">Sub Total:  ₹7,999</p>
//             <p className="text-end">Tax (5%): ₹150</p>
//             <h4 className="text-end total-amount">TOTAL: ₹8,149</h4>
//           </Col>
//         </Row><hr/>

//         {/* Late Charge */}
//         {/* <Row className="mb-4">
//           <Col>
//             <p>
//               <strong>Paid amount: </strong> <span className="total-due">₹8,149 INR</span>
//             </p>
//             <p>Late charge for 10 days</p>
//           </Col>
//         </Row> */}

//         {/* Terms */}
//         <Row>
//           <Col md={6}>
//             <h5>Terms & Conditions</h5>
//             <p>
//               Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
//               eiusmod tempor incididunt ut labore et dolore magna aliqua.
//             </p>
//           </Col>
//           <Col md={6}>
//           <div className='text-end' >
//              <img style={{width:'50%'}} src="https://www.signwell.com/assets/vip-signatures/bruce-lee-signature-40abf707b68d9bff51d53cfe915a429115247816f034e172a752b8f4ebc65b9f.svg" alt='main'/>
//              <h6>Peter Christopher</h6>
//              <span>Associate director</span>
//              </div>
//           </Col>
//         </Row>

//         {/* Footer */}
//         {/* <Row className="mt-5 text-center footer">
//           <Col>
//             <p>
//               <strong>123 Lungmen, Kazu Jakarta, Indonesia</strong>
//             </p>
//             <p>
//               Phone: (+62) 812 1234 1234 | Email: mail@admin.com
//             </p>
//             <p>Kazuma Jean | HR Director</p>
//           </Col>
//         </Row> */}
//       </Container>
//     </div>
//   );
// };

// export default SubscriptionBill;

